import { render, staticRenderFns } from "./CrearEnvioInformacionModal.vue?vue&type=template&id=2281f185&"
import script from "./CrearEnvioInformacionModal.vue?vue&type=script&lang=ts&"
export * from "./CrearEnvioInformacionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2281f185', component.options)
    } else {
      api.reload('2281f185', component.options)
    }
    module.hot.accept("./CrearEnvioInformacionModal.vue?vue&type=template&id=2281f185&", function () {
      api.rerender('2281f185', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/EnvioInformacion/CrearEnvioInformacionModal.vue"
export default component.exports